var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"notification toast",class:{
    'is-primary': _vm.toast.type === 'primary',
    'is-danger': _vm.toast.type === 'danger',
  }},[_c('button',{staticClass:"delete",on:{"click":_vm.closeToast}}),_vm._v(" "+_vm._s(_vm.toast.content)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }